"use client"

import { motion } from "framer-motion"
import { FaStar, FaQuoteLeft } from "react-icons/fa6"
import { useInView } from "react-intersection-observer"
import WaveDivider from "./wave-divider"

const reviews = [
    {
        text: "Netter kleiner Platz. Die Betreiber sind echt gechillt.",
        author: "Google Rezension"
    },
    {
        text: "Schöner Stellplatz in erster Lage, Mega Konzept mit Surf Schule und Lala Bar - beste Fischbrötchen!",
        author: "Google Rezension"
    },
    {
        text: "Netter Empfang und schön gelegener Stellplatz direkt hinterm Ostseestrand im Naturschutzgebiet.",
        author: "Google Rezension"
    },
    {
        text: "Super Stellplatz mit Charme, direkt hinter der Düne am Strandaufgang 14, ein beliebter Surf- und Kitestrand.",
        author: "Google Rezension"
    },
    {
        text: "Wer einen Stellplatz wenige Schritte vom Strand sucht und himmlische Ruhe genießen möchte ist hier genau richtig!",
        author: "Google Rezension"
    },
    {
        text: "Wir kamen für 2 Tage und blieben 2 Wochen. Danke an die freundlichen Betreiber!",
        author: "Google Rezension"
    }
]

export default function ReviewsSection() {
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true
    })

    return (
        <>
        <section className="relative overflow-hidden bg-gradient-to-b from-amber-200 via-amber-300 to-amber-400 pb-32 pt-20">
            {/* Decorative blobs */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -left-24 top-20 h-64 w-64 rounded-full bg-amber-500/30 blur-3xl" />
                <div className="absolute -right-32 bottom-32 h-96 w-96 rounded-full bg-amber-600/20 blur-3xl" />
            </div>

            <div ref={ref} className="relative mx-auto max-w-7xl px-4">
                {/* Header */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={inView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6 }}
                    className="mb-16 text-center"
                >
                    <span className="mb-4 inline-block font-handwritten text-2xl text-slate-700">
                        Was unsere Gäste sagen
                    </span>
                    <h2 className="font-special text-4xl font-bold text-slate-800 md:text-5xl lg:text-6xl">
                        Freiheit hinterm Deich
                    </h2>

                    {/* Star rating */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={inView ? { opacity: 1, scale: 1 } : {}}
                        transition={{ duration: 0.5, delay: 0.3 }}
                        className="mt-6 flex flex-col items-center gap-3"
                    >
                        <div className="flex items-center gap-1">
                            {[...Array(5)].map((_, i) => (
                                <motion.div
                                    key={i}
                                    initial={{ opacity: 0, rotate: -180 }}
                                    animate={inView ? { opacity: 1, rotate: 0 } : {}}
                                    transition={{ duration: 0.5, delay: 0.4 + i * 0.1 }}
                                >
                                    <FaStar className="h-8 w-8 text-amber-600 drop-shadow-sm" />
                                </motion.div>
                            ))}
                        </div>
                        <p className="text-sm font-medium text-slate-700">
                            Über 200 positive Reviews auf Google Maps
                        </p>
                    </motion.div>
                </motion.div>

                {/* Reviews Grid */}
                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {reviews.map((review, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 40 }}
                            animate={inView ? { opacity: 1, y: 0 } : {}}
                            transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                            className="group relative"
                        >
                            <div className="relative h-full overflow-hidden rounded-3xl bg-gradient-to-br from-white/80 to-amber-50/80 p-6 shadow-lg shadow-amber-900/10 backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-amber-900/20">
                                {/* Decorative quote */}
                                <FaQuoteLeft className="absolute -left-2 -top-2 h-16 w-16 text-amber-200/50 transition-transform duration-500 group-hover:scale-110" />

                                {/* Content */}
                                <div className="relative">
                                    <p className="mb-4 text-lg italic leading-relaxed text-slate-700">
                                        &ldquo;{review.text}&rdquo;
                                    </p>
                                    <div className="flex items-center gap-2">
                                        <div className="h-0.5 w-8 bg-amber-400" />
                                        <span className="text-sm font-medium text-slate-500">
                                            {review.author}
                                        </span>
                                    </div>
                                </div>

                                {/* Hover accent */}
                                <div className="absolute -right-8 -top-8 h-24 w-24 rounded-full bg-amber-300/30 transition-all duration-500 group-hover:scale-150" />
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

        </section>
        <WaveDivider variant="warm-to-warm" />
        </>
    )
}
